import React from 'react';
import './VerticalGridComponent.css';

interface IVerticalGridComponent {
    children?: React.ReactNode;
}

const VerticalGridComponent: React.FunctionComponent = (props: IVerticalGridComponent) => {
    return (
        <div className='d-flex flex-column w-100 h-100'>
            {props.children}
        </div>
    );
}

export default VerticalGridComponent;



// WEBPACK FOOTER //
// ./src/components/VerticalGridComponent/VerticalGridComponent.tsx